import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, getFormValues, reset } from 'redux-form';
import { connect } from 'react-redux';
import {
  MotifButton,
  MotifLabel,
  MotifTooltip,
  MotifTabNavigation,
  MotifTabControl,
} from '@ey-xd/motif-react';
import { useSelector } from 'react-redux';
import { addAttribute } from '../../common/Attribute';
import * as formHelpers from '../../scripts/formHelpers';
import { Link } from 'react-router';

const SignOffHeader = ({
  gridCurrentState,
  toggleShowSignOffModal,
  handleReportPeriodSelection,
  defaultReportPeriod,
  reportPeriods,
  noDataForReportPeriod,
}) => {
  useEffect(() => {
    //Add Attribute(type=button) to all button elements having attribute(role = 'combobox')
    addAttribute("button[role = 'combobox']", 'type', 'button');
  });

  let updateSignOffStatus = false;

  const periodsInSortedOrder = useMemo(() => {
    return [...reportPeriods]?.sort(
      (a, b) => new Date(b.endDate) - new Date(a.endDate)
    );
  }, [reportPeriods]);

  const uniquePeriodDescriptions = Array.from(
    new Set(periodsInSortedOrder.map((rp) => rp.reportPeriodDescription))
  ).map((periodDesc) => {
    return periodsInSortedOrder.find(
      (rp) => rp.reportPeriodDescription === periodDesc
    );
  });

  const reportPeriodOptions = uniquePeriodDescriptions.map((rp) => {
    return {
      key: rp.reportPeriodID,
      value: rp.reportPeriodDescription,
      text: rp.reportPeriodDescription,
    };
  });

  // Check if there is no reit selected
  if (!gridCurrentState || gridCurrentState.length === 0) {
    updateSignOffStatus = false;
  }
  // Check if there is any reit selected
  else if (gridCurrentState && gridCurrentState.length > 0) {
    if (gridCurrentState.some((x) => x.reitSelection == true)) {
      updateSignOffStatus = true;
    }
  }

  return (
    <>
      {/* Header area */}
      <div style={{ minHeight: '24px' }}></div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          className="mr-3 mt-auto mr-2"
          style={{ flex: '0 0 auto', marginBottom: '50px', minWidth: '200px' }}
        >
          <Field
            name="reportPeriod"
            label="Report Period"
            type="select"
            testingData={{ label: 'lblReportPeriod', div: 'divReportPeriod' }}
            onChange={handleReportPeriodSelection}
            options={reportPeriodOptions}
            component={formHelpers.SingleSelectComponent}
            defaultValue={defaultReportPeriod ? defaultReportPeriod : ''}
          />
        </div>
        <div style={{ flex: '1' }}></div>
        {/* Hide Update Sign Off Status button if noDataForReportPeriod is true */}
        {!noDataForReportPeriod && (
          <div style={{ width: 'fit-content', marginBottom: '10px' }}>
            <MotifButton
              type="button"
              variant="primary"
              aria-controls={'Update-Sign-Off-Status-Button'}
              aria-label="Update Sign Off Status"
              data-testid="btnUpdateSignOffStatus"
              disabled={!updateSignOffStatus}
              id={'Update-Sign-Off-Status-trigger'}
              onClick={() => {
                toggleShowSignOffModal();
              }}
            >
              Update Sign Off Status
            </MotifButton>
          </div>
        )}
      </div>
    </>
  );
};

SignOffHeader.propTypes = {
  defaultReportPeriod: PropTypes.string,
  reportPeriods: PropTypes.array,
  handleReportPeriodSelection: PropTypes.func.isRequired,
  enableSubmit: PropTypes.bool,
  handleSubmit: PropTypes.func,
  clientId: PropTypes.number,
};

export default SignOffHeader;
